import { LocalizationStrings } from "./LocalizationData";

const LocalizationLanguageEn: LocalizationStrings = {
	lang_nativeName: 'English',
	lang_selectionName: 'In English',
	lang_selectionTitle: 'Language selection',
	lang_selectionAccept: 'Accept',

	button_close: '',

	home_title: 'Questionnaire portal',
	home_description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin aliquam lacus eget posuere consectetur. Vivamus tincidunt quam augue, eu tristique diam rutrum sed. Morbi facilisis nulla massa, et bibendum purus egestas a. Phasellus quis ex varius ante dapibus semper. Proin dictum hendrerit fermentum. Fusce scelerisque lacinia nisi vel feugiat. In iaculis et orci vel egestas. Quisque ultricies lacinia suscipit.`,
	home_description_link: `eSpiral-lomaketta voit käyttää itsenäisesti ilman varsinaista Spiral-peliä. Tutustu halutessasi tarkemmin koko pelilliseen Spiral-menetelmään tästä.`,
	home_startQuestionnaire_button: 'start questionnaire',
	home_resultOpener_title: 'enter result code',
	home_resultOpener_submit: 'Get results',
	home_resultOpener_error_invalidFormat: 'Invalid format',
	home_resultOpener_button: 'Here for results?',

	question_answerQuestion_error: 'Answer all parts of question to continue!',
	question_help_title: 'Instruction',

	button_next: 'Next',
	button_previous: 'Previous',
	button_save: 'Save changes',


	preliminary_title: 'Preliminary Information',
	preliminary_description: `If wanted you can provide some preliminary information. Choose the most fitting choice in each section. Please refrain from writing sensitive information (eg. name or other personal information).`,

	preliminary_form_answer_noAnswer: "I don't want to answer",
	preliminary_form_other_text: "Other?",

	preliminary_age_title: 'Age',
	preliminary_answer_age_title: 'Age',

	preliminary_gender_title: 'Gender',
	preliminary_answer_gender_title: 'Gender',
	preliminary_gender_choices: {
		male: 'mies',
		female: 'nainen',
		other: 'muu'
	},

	preliminary_firstLanguage_title: 'First language',
	preliminary_answer_firstLanguage_title: 'First language',
	preliminary_firstLanguage_choices: {
		fi: "Suomi",
		sv: "Ruotsi",
		other: "jokin muu, mikä?"
	},

	preliminary_education_title: 'Level of education',
	preliminary_answer_education_title: 'Level of education',

	preliminary_education_choices: {
		publicSchool: 'peruskoulu',
		upperSecondarySchool: 'ylioppilastutkinto',
		vocationalSchool: 'ammatillinen tutkinto (2. aste)',
		appliedSciencesUniversity: 'ammattikorkeakoulututkinto',
		university: 'yliopistotutkinto',
		other: 'muu, mikä?'
	},

	preliminary_activity_title: 'Activity',
	preliminary_answer_activity_title: 'Activity',

	preliminary_activity: {
		student: 'koululainen tai opiskelija',
		employed: 'työsuhteessa tai yrittäjänä (myös osa-aikainen työ)',
		supportedWork: 'tuetussa työssä (esim. työpajassa, työharjoittelussa, työkokeilussa)',
		leave: 'pitkällä sairauslomalla tai kuntoutustuella',
		unemployed: 'työtön',
		paternityservice: 'vanhempainvapaalla tai armeijassa',
		retired: 'eläkkeellä (esim. vanhuus- tai tykyvyttömyyseläke)',
		other: 'jokin muu, mikä?'
	},

	preliminary_fillReason_title: 'Fill reason:',
	preliminary_answer_fillReason_title: 'Fill reason:',

	preliminary_fillReason: {
		self: 'omasta mielenkiinnosta',
		TE: 'ammattilaisen pyynnöstä TE-palveluissa',
		hc: 'ammattilaisten pyynnöstä terveydenhuollossa',
		edu: 'ammattilaisen pyynnöstä oppilaitoksessa',
		kela: 'ammattilaisen pyynnöstä Kelan palveluissa',
		org: 'ammattilaisen pyynnöstä 3. sektorilla (esim. järjestöt ja säätiöt)',
		testing: 'tutustun kyselyyn kokeilemalla vastaamista',
		other: 'muusta syystä:',
	},
	finish_sendResults: 'Submit',
	finish_noAnswer: 'ei vastausta',

	error_result: 'Result loading failed',
	error_result_notFound: 'Result not found',
	error_generic: 'Something went wrong',

	button_tryAgain: 'Try again',
	button_toHome: 'To home',

	terms_title: 'Terms of service',
	terms_button_accept: 'I Accept terms',

	reset_title: 'Hey',
	reset_body: 'You have unfinished questionnaire. ({0}) Would you like to continue it?',

	button_yes: 'Yes',
	button_no: 'No',

	button_start: 'Start',
	button_cancel: 'Cancel',

	start_description: 'would you like to start questionnaire?',

	button_endQuestionnaire: 'End questionnaire',
	endQuestionnaire_title: 'Are you sure you want to end questionnaire',

	button_send: 'Send results',

	finish_title: 'Koostesivu',
	finish_description_start: `Valitse alla näkyvistä vastauksistasi 1-3 tärkeintä, joihin tavoittelet muutosta.`,
	finish_description: 'Tällä sivulla voit tarkistaa vastauksesi ja muokata niitä halutessasi. Kun olet valmis, valitse ”Lähetä tulokset”. Näin saat koodin ja linkin, joiden avulla voit tarkastella myöhemmin tuloksiasi sekä jakaa ne haluamallesi taholle.',

	finish_answers_title: 'Answers',
	finish_highlightError: 'You must highlight atleast one question',
	finish_highlight: 'Merkitse muutoskohteeksi',
	finish_unhighlight: 'Poista muutoskohteista',

	button_shareResult: 'Share or store result...',
	button_copyUrl: 'Copy link',
	button_copyCode: 'Copy code',
	resultSharing_title: 'Result sharing',
	resultSharing_urlShare: 'You can share your result with others with this link',
	resultSharing_codeShare: 'You can share your result with other with this code.',

	resultSharing_survey: 'Anna palautetta lomakkeesta',

	resultSharing_description: `Säilytämme tuloksiasi kolme kuukautta. Voit tarkastella niitä myöhemmin alla olevalla linkillä tai koodilla. Voit jakaa ne haluamallesi taholle liittämällä linkin/koodin sähköpostiviestiin (liitä painamalla Ctrl + V tai hiiren oikea näppäin + Liitä)`,

	resultSharing_urlShare_copied: 'Link copied',
	resultSharing_codeShare_copied: 'Code copied',

	answers_title: 'Results',
	answers_answers_title: 'Answers',
	answers_resultCode: 'Result code:',
	answers_resultCode_end: 'Ota koodi talteen!',
	answers_target_title: 'Targets',

	button_printPdf: 'Print results',
	button_exit: 'Exit',

	loading: 'Loading...',
	sending: 'Sending...',

	questionnaireList_choose_title: 'Choose questionnaire',

	button_toSummary: 'To summary',
	button_openPicture: 'Katso kuvaesimerkki',

	answers_secondary_answer_Value_texts: {
		'-1': 'En toivo muutosta asiaan',
		'0': 'En osaa sanoa',
		'1': 'Toivon muutosta asiaan'
	},
	button_instructions: 'Ohjeistus'

}
export default LocalizationLanguageEn;
